import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnCameraType extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public icon: string;

  @Expose()
  public color: string;

  @Expose()
  public scale: number;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
